import { ProgressEvent } from '../../../adapters';
import {
    ContentDuration,
    IContent,
    MediaControllerState,
    PlanetMediaPlayer,
    PlanetUserInteractionArgs,
    PlaybackSessionState,
    TimeSpan,
} from '../../../media-player';
import { ScriptLoader } from '../../../utils';
import { VideoAnalyticsTrackerType } from './enums';
import { MatomoOptions } from './models/matomo-options';
import { PlaybackSessionTracker } from './playback-session-tracker';

export class MatomoAnalyticsTracker extends PlaybackSessionTracker<VideoAnalyticsTrackerType.Matomo, MatomoOptions> {

    private scriptLoader: ScriptLoader;

    private playbackSession: PlaybackSessionState;

    constructor() {
        super();
        this.scriptLoader = new ScriptLoader();
    }

    async setup(player: PlanetMediaPlayer, options: MatomoOptions): Promise<PlaybackSessionTracker<VideoAnalyticsTrackerType.Matomo, MatomoOptions>> {
        await super.setup(player, options);
        this.options = options;
        const base: string = options?.base;
        const srcUrl: string = options?.srcUrl;
        const siteId: string = options?.siteId;
        const userId: string = options?.userId;
        if (base && srcUrl) {
            let analyticsCode = `
  var _paq = window._paq = window._paq || [];
  `;
            if (userId) {
                analyticsCode += `_paq.push(['setUserId', '${userId}']);`;
            }
            analyticsCode += `
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="${base}";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '${siteId}']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.type='text/javascript'; g.async=true; g.src='${srcUrl}'; s.parentNode.insertBefore(g,s);
  })();
        `;
            await this.scriptLoader.requireCode(analyticsCode);
        }

        return this;
    }

    dispose(): void {
    }

    onError(error: Error): void {
    }

    onSetupError(setupError: Error): void {
    }

    onUserInteraction(event: PlanetUserInteractionArgs): void {
    }

    trackContentLoad(content: IContent, index: number): void {
    }

    trackPlaybackComplete(): void {
    }

    trackPlaybackPause(position: number, duration: ContentDuration, state: MediaControllerState, played: TimeSpan): void {
    }

    trackPlaybackResume(position: number, duration: ContentDuration): void {
    }

    trackPlaybackStart(position: number, duration: ContentDuration): void {
    }

    trackSeek(position: number): void {
    }

    trackSessionCreate(session: PlaybackSessionState): void {
        this.playbackSession = session;
    }

    trackSessionEnd(session: PlaybackSessionState): void {
    }

    trackStateChange(oldState: MediaControllerState, newState: MediaControllerState): void {
    }

    onBufferChange(data: ProgressEvent): void {
    }
}
